/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from 'react';
import moment from 'moment';
import { useShallow } from 'zustand/react/shallow';
import { HumanUserIcon } from '../Assets/HumanUserIcon';
import { EstimatorType } from './types';
import { EstHoursModal } from './EstHoursModal';
import { addHoursText, estHoursText, estimatorName, styledDotIcon, styledHoursData, userScope } from './styles';
import { EditLineIcon } from '../Assets/EditLineIcon';
import { CircularDotIcon } from '../Assets/CircularDotIcon';
import { Checklist } from './Checklist';
import { AssignmentState, useScopeStore } from './useScopeChange';

const EstHours = ({ startDate, endDate, estHours }: { startDate: string; endDate: string; estHours: number }) => (
  <>
    {startDate ? moment(startDate).format('DD/MM/YYYY') : '-'}
    <CircularDotIcon className={styledDotIcon} />
    <div style={{ minWidth: 'fit-content' }}>
      {Math.floor(estHours / 60)} hrs {estHours % 60} min
    </div>
    <CircularDotIcon className={styledDotIcon} />
    {endDate ? moment(endDate).format('DD/MM/YYYY') : '-'}
  </>
);

export const UserScope = ({
  isCurrentUser,
  userPersona,
  assignment,
  isQcScope = true,
  tradeId
}: {
  isCurrentUser: boolean;
  userPersona?: EstimatorType;
  assignment: AssignmentState;
  isQcScope?: boolean;
  tradeId: string;
}) => {
  const { user, estimated_minutes: estHours, start_date: startDate, end_date: endDate, scope, id } = assignment;

  const { setAssignment } = useScopeStore(useShallow(state => ({ setAssignment: state.setAssignment })));

  const [openEstHoursModal, setOpenEstHoursModal] = useState(false);

  return (
    <>
      <div className={userScope}>
        <div className={estimatorName}>
          <HumanUserIcon width='1rem' height='1rem' />
          <div>
            {user.name}
            {isCurrentUser && ' (You)'}
          </div>
        </div>
        <div className={estHoursText}>
          {!!estHours && (
            <div className={styledHoursData}>
              <EstHours startDate={startDate ?? ''} endDate={endDate ?? ''} estHours={estHours ?? 0} />
              {isCurrentUser && (
                <EditLineIcon onClick={() => setOpenEstHoursModal(true)} style={{ cursor: 'pointer' }} />
              )}
            </div>
          )}
          {isCurrentUser && !estHours && (
            <div className={addHoursText} onClick={() => setOpenEstHoursModal(true)}>
              Add your estimate hours
            </div>
          )}
          {!estHours && !isCurrentUser && <div>-</div>}
        </div>
        {isQcScope && (
          <Checklist
            isCurrentUser={isCurrentUser}
            userPersona={userPersona}
            scope={scope}
            tradeId={tradeId}
            assignmentId={id}
          />
        )}
      </div>
      {openEstHoursModal ? (
        <EstHoursModal
          show={openEstHoursModal}
          onClose={() => setOpenEstHoursModal(false)}
          start={startDate}
          end={endDate}
          hours={estHours}
          onSave={val => {
            setAssignment(tradeId, id, {
              start_date: val.startDate,
              end_date: val.endDate,
              estimated_minutes: val.estHours
            });
            setOpenEstHoursModal(false);
          }}
        />
      ) : null}
    </>
  );
};
